
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Créer un site Internet de serrurier – Exemples, Prix et Délais",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Quel est le prix d’un site Web de serrurier ? À qui en confier la réalisation ? Cet article vous dit tout !",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Créer un site Internet de serrurier – Exemples, Prix et Délais",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Quel est le prix d’un site Web de serrurier ? À qui en confier la réalisation ? Cet article vous dit tout !",
        },
      ],
    };
  },
};
